import * as C from '../consts';
// import * as M from '../models';
import { boundApiReducer as api, boundReducer } from 'redux-upgrader';
// import DEPRECATED_moment from 'moment-timezone';
import Cookies from 'js-cookie';
import { Settings } from 'luxon';

/* PROFILE */

export const currentUser = api(
    C.GET_CURRENT_USER,
    Object,
    null,
    (action) => action.data.current_user
);

const defaultTimezone =
    Cookies.get('ruptly_timezone') || Settings.defaultZoneName;

export const timezone = boundReducer(defaultTimezone, {
    [C.SET_TIMEZONE]: (_state, action) => action.value,
});

export const country = boundReducer(
    {},
    {
        [C.SET_USER_COUNTRY]: (_state, action) => action.country,
    }
);

export const companyCountry = boundReducer(
    {},
    {
        [C.SET_COMPANY_COUNTRY]: (_state, action) => action.country,
    }
);

export const transactions = api(C.GET_TRANSACTIONS, Array);

/* / PROFILE */

export const newslettersPopupDates = api(C.NEWSLETTERS_POPUP_DATES, Object);
export const sendToPardot = api(C.SEND_TO_PARDOT, Object);
